import { useCallback, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useLocation } from 'react-router-dom';
import useAuth from 'context/useAuth';
import { getPageName } from 'i18n';

import { tagEvent as gtmTagEvent, tagStepChange } from '../tagManager';
const usePageViews = () => {
    const { user } = useAuth();
    const { locale } = useIntl();
    const location = useLocation();
    const { pathname, state } = location;

    const previousPageUrl = useMemo(() => (!state || !state.from ? '' : state.from.pathname), [state]);

    const stepChange = useCallback(
        (changeInfo = {}) => {
            let { currentPageName, previousPageName, ...rest } = changeInfo;
            currentPageName = currentPageName || getPageName(pathname);
            tagStepChange({
                currentPageName,
                currentPageUrl: pathname,
                locale,
                pageType: currentPageName,
                previousPageName: previousPageName || getPageName(previousPageUrl),
                previousPageUrl: previousPageUrl,
                time: Date.now(),
                userId: user ? user.cognitoSubId : '',
                ...rest,
            });
        },
        [locale, pathname, previousPageUrl, user]
    );

    const tagEvent = useCallback(
        (event) => {
            gtmTagEvent({
                locale,
                userId: user.cognitoSubId,
                ...event,
            });
        },
        [user, locale]
    );

    return { stepChange, tagEvent };
};

export default usePageViews;
